"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGArrow = void 0;
const CTGAnimatingTextContainer_1 = require("./CTGAnimatingTextContainer");
class CTGArrow extends Phaser.GameObjects.Container {
    constructor(scene, name, description) {
        super(scene);
        this.arrow = scene.add.sprite(-4, 0, 'arrow').setOrigin(0);
        this.add(this.arrow);
        this.game_name_text = scene.add.bitmapText(1, 1, 'font', name.toUpperCase(), 6).setTint(0x0).setOrigin(0);
        this.add(this.game_name_text);
        this.text_container = new CTGAnimatingTextContainer_1.CTGAnimatingTextContainer(scene, 60, description);
        this.text_container.y = 7;
        scene.add.existing(this.text_container);
        this.add(this.text_container);
    }
    full_height() {
        return this.text_container.full_height + 7;
    }
    animate_in_no_dropdown(length, callback) {
        this.x = -64;
        this.scene.tweens.add({
            targets: this,
            x: 0,
            ease: 'Quad.easeOut',
            duration: length / 2,
            onComplete: () => {
                this.scene.tweens.add({
                    targets: this,
                    x: 74,
                    ease: 'Quad.easeIn',
                    duration: length / 2,
                    delay: 0,
                    onComplete: () => {
                        this.x = 74;
                        if (callback)
                            callback();
                    }
                });
            }
        });
    }
    animate_in(callback) {
        this.x = -64;
        this.scene.tweens.add({
            targets: this,
            x: 0,
            ease: 'Quad.easeOut',
            duration: 500,
            onComplete: () => {
                this.text_container.animate_in(0, () => {
                    this.text_container.animate_out(2500, () => {
                        this.scene.tweens.add({
                            targets: this,
                            x: 74,
                            ease: 'Quad.easeIn',
                            duration: 500,
                            delay: 0,
                            onComplete: () => {
                                this.x = 74;
                                if (callback)
                                    callback();
                            }
                        });
                    });
                });
            }
        });
    }
    animate_out() {
    }
}
exports.CTGArrow = CTGArrow;
